import { axios } from '../request'

export default (_app) => {
  return {
    namespaced: true,
    actions: {
      load(context) {
        return axios.get(`explainer`).then((res) => {
          if (typeof res.data !== 'undefined') {
            if (typeof res.data.data !== 'undefined') {
              Object.keys(res.data.data).forEach((key) => {
                const item = res.data.data[key]
                if (typeof context.rootState[key] !== 'undefined') {
                  context.dispatch(`${key}/explain`, item, { root: true })
                }
              })
            }
          }
        })
      },
    },
  }
}
